// extracted by mini-css-extract-plugin
export var subtitle = "_cz-2";
export var title = "_cz-0";
export var titleNoWrap = "_cz-1";